import React from 'react';
import { useTranslation } from 'react-i18next';

import BaseComposer from '../BaseComposer';

const DeactivatedComposer = () => {
  const { t } = useTranslation('bots');

  return (
    <BaseComposer
      value={''}
      onChange={() => {}}
      handleSubmit={() => {}}
      showBurgerIcon={false}
      disabled
      placeholder={t('deactivated_composer_label')}
      aria-label={t('deactivated_composer_label')}
    />
  );
};

export default DeactivatedComposer;
